import { Platform } from 'react-native';

/**
 * Shared list/scroll props for screens with **manual** sticky/overlay headers
 * (`ScreenHeader`, menu flow chrome, dashboard).
 *
 * Always set `contentInsetAdjustmentBehavior: 'never'` — iOS defaults to
 * `automatic`, which adds a second safe-area inset on top of the padding we already
 * compute in `useHeaderTopPadding` / list header spacers (calendar / accounts / menu).
 */
export const MENU_FLOW_FLAT_LIST_PROPS = {
  removeClippedSubviews: Platform.OS === 'android',
  initialNumToRender: 7,
  maxToRenderPerBatch: 6,
  windowSize: 5,
  updateCellsBatchingPeriod: 50,
  contentInsetAdjustmentBehavior: 'never' as const,
  automaticallyAdjustContentInsets: false,
} as const;

/** Shared vertical `ScrollView` / `Animated.ScrollView` tuning for hub screens. */
export const SCROLL_VIEW_PROPS = {
  removeClippedSubviews: Platform.OS === 'android',
  nestedScrollEnabled: false,
  showsVerticalScrollIndicator: false,
  contentInsetAdjustmentBehavior: 'never' as const,
  automaticallyAdjustContentInsets: false,
} as const;
